import { skipToken, useQuery } from '@tanstack/react-query';

import { Assets } from '@air/api';
import { callAirApi } from '@air/utils-api';

import { type TagBase } from '~/components/Tags/utils';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

export type ListCommonTagsResponse = { tags: TagBase[] };

export const ASSET_VERSION_TAGS_LIST_COMMON_KEY = 'ASSET_VERSION_TAGS_LIST_COMMON';

export type UseAssetVersionTagsListCommonParams = {
  boardId: string | undefined;
  includeDescendants: boolean;
};

export type UseAssetVersionTagsListCommonOptions = {
  enabled: boolean;
};

export const getAssetVersionTagsListCommonKey = (params: UseAssetVersionTagsListCommonParams) => [
  ASSET_VERSION_TAGS_LIST_COMMON_KEY,
  params,
];

export const useAssetVersionTagsListCommon = (
  params: UseAssetVersionTagsListCommonParams,
  options: UseAssetVersionTagsListCommonOptions,
) => {
  const { currentWorkspace } = useCurrentWorkspace();
  const workspaceId = currentWorkspace?.id;
  const { boardId, includeDescendants } = params;
  const { enabled } = options;

  return useQuery({
    queryKey: getAssetVersionTagsListCommonKey(params),
    queryFn:
      workspaceId && boardId
        ? () =>
            callAirApi<ListCommonTagsResponse>(() =>
              Assets.Versions.Tags.listCommon({
                workspaceId,
                boardId,
                includeDescendants,
              }),
            )
        : skipToken,
    select: (data) => data.tags,
    enabled: enabled && !!workspaceId && !!boardId,
  });
};
